import trackCount from "./ads/track-count";
import setupComment from "./comment/setup-comment";
import setupLikeComment from "./comment/setup-like-comment";
import initContextMenu from "./context-menu/context-menu";
import setupDotsMenu from "./dots-menu/setup-dots-menu";
import setupPhotoPopup from "./photo-popup/setup-photo-popup";
import deletePhoto from "./photo/delete-photo";
import setupLikePhoto from "./photo/setup-like-photo";
import {
	setupReportingPopup,
	setupReportingSubmission,
} from "./reporting/setup-reporting";
import { setupMetadataHover } from "./photo/setup-metadata-hover";
import { masonryOpts } from "./common/config";
import setupNotification from "./notification/notification";
import setupFollowArtist from "./artist/follow";
import setupGuidelines from "./misc/setup-guidelines";
import { openPopup, setupClosePopup, setupOpenPopup } from "./popup/popup";
import setupInlineEditing from "./inline-editing/setup-inline-editing";
import setupTabs from "./tabs/setup-tabs";
import setupDataModel from "./common/setup-data-model";
import setupPaidPlatformAnnouncement from "./site/setup-paid-platform-announcement";

declare var FlexMasonry: any;

declare var pm: PmInterface;

(function () {
	const { findHtmlEl, findHtmlEls, getClosest } = pm.utils.dom;

	const isLoggedIn = document.body.classList.contains("logged-in");
	const contextMenu = findHtmlEl(".context-menu");

	init();

	function init() {
		if (contextMenu) initContextMenu();

		document.addEventListener("click", handleDocumentClick);

		FlexMasonry.init(".use-masonry", masonryOpts);

		setupDataModel();
		setupTabs();
		registerPopups();
		setupGuidelines(jQuery);
		setupNotification();
		setupFollowArtist();
		setupLikePhoto();
		setupPhotoPopup();
		setupInlineEditing();
		setupDotsMenu();
		setupAdsTracking();
		setupPaidPlatformAnnouncement();
		setupReporting();
		setupComment();
		setupLikeComment();

		const photoMetadataArea = findHtmlEl(".metadata-mousemove");

		if (photoMetadataArea) {
			setupMetadataHover(photoMetadataArea);
		}
	}

	function handleDocumentClick(e: MouseEvent) {
		const target = e.target as HTMLElement | null;
		if (!target) return;

		checkDeletePhoto(target);
	}

	function registerPopups() {
		const popupOverlays = findHtmlEls(".popup-overlay[data-popup-name]");

		if (popupOverlays.length) {
			popupOverlays.forEach(function (popupOverlay) {
				const popupName = popupOverlay.dataset.popupName;
				if (!popupName) return;

				setupOpenPopup(popupName);
				setupClosePopup(popupName);
			});
		}

		pm.event.on("pm_open_popup_via_api", (opts) => {
			openPopup(opts.name);
		});
	}

	function checkDeletePhoto(clickTarget: HTMLElement) {
		if (!isLoggedIn) return;
		const deleteButton = getClosest(clickTarget, ".delete-photo", 10);
		if (!deleteButton) return;

		const isReview = deleteButton.classList.contains("is-review");
		const contextMenu = getClosest(deleteButton, ".context-menu", 5);

		const photoId = contextMenu
			? contextMenu.dataset.photoId
			: deleteButton.dataset.photoId;

		if (!photoId) return;
		deletePhoto(photoId, isReview);
	}

	function setupAdsTracking() {
		pm.event.on("ad_loaded", (opts) => {
			trackCount(opts.id, "load");
		});

		document.addEventListener("click", (e: MouseEvent) => {
			const target = e.target as HTMLElement;
			const adGridItem = getClosest(target, ".is-spc") as HTMLElement;
			if (!adGridItem) return;
			const adsIdStr = adGridItem.dataset.spcId;
			if (!adsIdStr) return;
			trackCount(parseInt(adsIdStr, 10), "click");
		});
	}

	function setupReporting() {
		const popup = findHtmlEl(".reporting-popup");
		if (!popup) return;

		setupReportingPopup();
		setupReportingSubmission();
	}
})();
